/**
* HashHandler
*/

class HashHandler {
    constructor() {
        var that = this;

        this.actions = [];
        this.timeout = null;

        this.enable();

        return this;

    }

    hashChangeHandler() {
        var hash = window.location.hash;

        for(var i in this.actions) {
            if(this.actions[i].parameter) {
                var length = this.actions[i].hash.length;

                if(this.actions[i].hash == hash.substr(0, length)) {
                    if(this.actions[i].callback) {
                        this.actions[i].callback(hash.substr(length + 1));
                    }

                    break;
                }
            }
            else {
                if(this.actions[i].hash == hash) {
                    if(this.actions[i].callback){
                        this.actions[i].callback();
                    }

                    break;
                }
            }
        }
    }

    enable() {
        var that = this;

        $(window).bind('hashchange', function() {
            that.hashChangeHandler();
        });
    }

    disable() {
        $(window).unbind('hashchange');
    }

    addAction(hash, parameter, callback) {
        var that = this;

        this.actions.push({
            hash: hash,
            parameter: parameter,
            callback: callback
        });

        window.clearTimeout(this.timeout);
        this.timeout = window.setTimeout(function() {
            that.hashChangeHandler();
        }, 50);
    }

    clearHash() {
        if (window.history && window.history.pushState) {
            window.history.pushState(null, null, ' ');
        }
        else {
            window.location.href = '#';
        }
    }
}

export { HashHandler }
